const { Core, Utils, Cache } = Global;
const { $fetch, debounce, $toggleDisplay, $replaceContent, $active, $loading, setDocumentClickHandler } = Utils;

const RQ_SECTION = 'r_predictive-search';
const RQ_SECTION_SELECTOR = '[data-template]';
const ATTR_NO_RESULTS = 'data-empty-results';
const DEFAULT_MIN_CHARS = 1;
const DEFAULT_LIMIT = 5;
const DEBOUNCE_INTERVAL = 150;

customElements.define('predictive-search', class extends Core {
    propTypes = {
        'results-limit': Number
    }

    elements = {
        $: ['search-input', 'product-type-select', 'button', 'results', 'initial']
    }

    render() {
        this.$('search-input', {
            focus: this._handleFocus,
            input: debounce(this._handleInput.bind(this), DEBOUNCE_INTERVAL)
        });
        this.$('button', {
            click: this._handleButtonClick
        });
        this.$('product-type-select', {
            change: this._handleTypeSelect
        });
        this._toggleDocClickListener = setDocumentClickHandler(this._handleOuterClick.bind(this));
    }

    _handleTypeSelect() {
        this._handleInput();
        this.$('search-input').focus();
    }

    _handleButtonClick(e) {
        if (this.$('search-input').value) return;
        e.preventDefault();
        this.$('search-input').focus(); 
    }

    _handleFocus() {
        if (this.minQueryChars) this._handleInput();
        else this.active = !!this.$('initial');
    }

    async _handleInput() {
        const query = this.query;
        const requestId = this._requestId = (this._requestId || 0) + 1;
        if (!this.minQueryChars) {
            this.showResults = false;
            this.active = false;
            return;
        }
        try {
            const key = 'snp-products:' + query;
            if (!Cache.has(key)) {
                const doc = await $fetch(routes.predictive_search_url, {
                    params: {
                        q: query,
                        'resources[type]': 'product',
                        'resources[limit]': this.limit,
                        'section_id': RQ_SECTION
                    },
                    select: RQ_SECTION_SELECTOR
                });
                if (!doc) throw new Error('No search response');
                Cache.set(key, { hasResults: !doc.hasAttribute(ATTR_NO_RESULTS), content: doc });
            }
            if (requestId !== this._requestId || query !== this.query) return;
            $replaceContent(this.$('results'), Cache.get(key).content);
            this.showInitial = false;
            this.showResults = true;
            this.active = true;
        } catch (error) {
            if (requestId !== this._requestId) return;
            this.showResults = false;
            this.active = false;
        }
    }

    _renderQueryResults() {
        const currentQuery = Cache.get(this.query);

        $replaceContent(this.$('results'), currentQuery.content);

        this.showInitial = !currentQuery.hasResults;
        this.showResults = true;
    }

    _handleOuterClick(e) {
        if(!this.contains(e.target) && this.active && document.activeElement !== this.$('search-input')) {
            this.active = false;
        }
    }
    
    _loading(state) {
        return () => {
            $loading(this, state);
        }
    }
    
    set showInitial(state) {
        if(!this.$('initial')) {
            this.active = false;
            return;
        }

        $toggleDisplay(this.$('initial'), state);
        this.active = state;
    }

    set showResults(state) {
        $toggleDisplay(this.$('results'), state);
    }

    set active(state) {
        if (state === this._active) {
            return;
        }
        this._toggleDocClickListener(state)
        $active(this, state);
        this._active = state;
    }

    get active() {
        return !!this._active;
    }

    get minQueryChars() {
        return this.$('search-input').value.trim().length >= DEFAULT_MIN_CHARS;
    }

    get query() {
        const inputValue = this.$('search-input').value.trim();
        if (this.$('product-type-select') && this.$('product-type-select').value !== "") {
            return `product_type:${this.$('product-type-select').value} AND ${inputValue}`
        }
        return inputValue;
    }
    
    get limit() {
        return this.prop('results-limit') || DEFAULT_LIMIT;
    }
});
